import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=6c30fefe&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"
import style0 from "./Download.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Download.vue?vue&type=style&index=1&id=6c30fefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30fefe",
  null
  
)

export default component.exports